<div class="wrapper">
    <div class="container">
        <div class="brd_bx">
            <div class="col-sm-12">
                <div class="page-title-box">

                    <h4 class="page-title">Imported Sports News</h4>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="card m-b-30">
                        <div class="card-body">

                            <table class="table">
                                <thead>
                                    <tr>
                                        <th><button *ngIf="show_multiple_delete_btn"
                                                class="btn btn-outline-danger waves-effect waves-light"
                                                (click)="delete_multiple_news()"><i class="fa fa-trash"></i></button>
                                        </th>
                                        <th>Gujarati Title</th>
                                        <th>Date</th>
                                        <th>Active<br>
                                            <input type="checkbox" id="mainCheckbox"
                                                (change)="activeDeactiveAll($event)"><br>
                                            <button *ngIf="show_multiple_active_btn" class="btn btn-info btn-sm"
                                                (click)="active_all()">Active </button>
                                        </th>
                                        <th>Active & Notification</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let mn of sportsList">
                                        <input type="hidden" value="{{mn._id}}" class="news_ids">
                                        <td class="text-center"><input type="checkbox" ng-model="sports_news_id"
                                                (change)="add_delete_checkbox($event,mn._id)"></td>
                                        <td>
                                            <a routerLink="/sports-news-edit/{{mn._id}}"
                                                [innerHTML]="mn.sports_guj_title"></a>

                                        </td>
                                        <td>{{mn.sports_news_date}}</td>
                                        <td class="text-center">
											<input type="checkbox" class="newsStatus"
												(change)="update_news_status($event,mn._id)" value="{{mn._id}}">
										</td>
                                        <td class="text-center">
											<input type="checkbox" class="newsNoti"
												(change)="update_news_noti($event,mn._id)" value="no">
										</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>